import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Definizione } from '../../../shared/interface';
import { Table } from 'primeng/table';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-abbecedario-backoffice',
  templateUrl: './abbecedario-backoffice.component.html',
  styleUrl: './abbecedario-backoffice.component.css'
})
export class AbbecedarioBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild("deleteDefinizione") deleteDefinizione!: ConfirmPopup;

  definizioni: Definizione[] = [];
  loading: boolean = false;

  ngOnInit(): void {
    
    this.loading = true;

    this.apiService.setDefinizioni();
    this.apiService.definizioniChanged.subscribe({
      next: (data) => {
        this.definizioni = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteDefinizione(event: Event, definizione: Definizione) {        
    this.confirmationService.confirm({      
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare la definizione?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteDefinizione(definizione.id).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {  
            this.confirmationService.close()
            this.apiService.setContatti()
            this.apiService.message("success", "Eliminazione", "La definizione è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDeleteDefinizione() {
    this.deleteDefinizione.accept();
  }

  onAnnullaDeleteDefinizione() {
    this.deleteDefinizione.reject();
  }

}
